var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "track",
    staticClass: "Polaris-ColorPicker__Slidable",
    on: {
      "mousedown": _vm.startDrag,
      "touchstart": _vm.startDrag
    }
  }, [_c('div', {
    ref: "dragger",
    staticClass: "Polaris-ColorPicker__Dragger",
    style: (_vm.draggerStyle)
  })])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-beea5e20", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-beea5e20","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisColorPickerSlidable.vue
// module id = 259
// module chunks = 0